import React from 'react';

const SvgArrowDownSmall = props => (
  <svg width={8} height={5} {...props}>
    <path
      d="M7.805 1.195l-3.31 3.31a.7.7 0 0 1-.99 0l-3.31-3.31A.7.7 0 0 1 .69 0h6.62a.7.7 0 0 1 .495 1.195z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgArrowDownSmall;
